import { render, staticRenderFns } from "./modal-tags.vue?vue&type=template&id=ca74b390&"
import script from "./modal-tags.vue?vue&type=script&lang=js&"
export * from "./modal-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports